<template>
  <k-dialog>
    <div class="dialog-effect-wrapper">
      <img :src="img.aniImg || defaultImg" class="bg" />
      <img
        :src="img.aniBtn || defaultBtn"
        class="btn y-rotate"
        :style="aStyle"
      />
    </div>
  </k-dialog>
</template>
<script>
import KDialog from '@com/base/Dialog';
export default {
  name: 'RedpackEffect',
  props: {
    img: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      defaultImg:
        '//cdn-tx-admin-test.3kwan.com/2023/07/13/da56a065174daef53b88f9d92df173cc.png',
      defaultBtn:
        '//cdn-tx-admin-test.3kwan.com/2023/07/13/2e90814aef94190817cf330c6cc95148.png'
    };
  },
  components: {
    KDialog
  },
  computed: {
    aStyle() {
      return {
        width: this.$unit(this.img.btnWidth),
        left: this.$unit(this.img.btnLeft),
        bottom: this.$unit(this.img.btnBottom)
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-effect-wrapper {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 501;
  img.bg {
    display: block;
    width: 360px;
  }
  .btn {
    position: absolute;
  }
}
.y-rotate {
  animation: yrote 1.5s infinite linear;
}
</style>
<style>
@keyframes yrote {
  0% {
    transform: rotateY(0);
  }

  100% {
    transform: rotateY(360deg);
  }
}
</style>
